import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import type { IdeaBook } from "./types";

const GET_IDEA_BOOKS = gql`
  query GetIdeaBooks($homeownerId: ID!) {
    getIdeaBooks(homeownerId: $homeownerId) {
      _id
      homeownerId
      name
      itemCount
      createdAt
      updatedAt
      coverImage {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type GetIdeaBooksData = {
  getIdeaBooks: IdeaBook[];
};

type GetIdeaBooksVars = {
  homeownerId: string;
};

export const useGetIdeaBooks = () => {
  const [getIdeaBooksQuery, { loading, error, data }] = useLazyQuery<
    GetIdeaBooksData,
    GetIdeaBooksVars
  >(GET_IDEA_BOOKS);

  const getIdeaBooks = useCallback(
    async (homeownerId: string, refresh: boolean = false) => {
      const result = await getIdeaBooksQuery({
        variables: { homeownerId },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result.data?.getIdeaBooks ?? [];
    },
    [getIdeaBooksQuery]
  );

  return {
    getIdeaBooks,
    loading,
    error,
    ideaBooks: data?.getIdeaBooks ?? [],
  };
};
